<template>
  <div class="content invest">
    <div class="aside">
      <div class="top">
        <p style="color:#fff;fontSize:18px;textAlign:center">平台监测项目情况</p>
        <div class="conBox">
          <div class="sin" v-for="item in inverstStatusArr" :key="item.title">
            <p>{{item.title}}</p>
            <p style="color:#00FFFF;fontSize:12px;display: flex;justify-content:center">
              {{item.num}}
              <span style="fontSize:12px">{{item.unit}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="asideSurvey">
        <p>平台监测“565”产业投资分类</p>
        <div :id="'pieOne'+tag"></div>
        <div :id="'pieTwo'+tag"></div>
        <div :id="'pieThree'+tag"></div>
      </div>
    </div>
    <div class="center">
      <div class="totalSurver">
        <p style="color:#fff;fontSize:14px">{{investment.name}}</p>
        <p style="color:#fff;fontSize:12px">
          项目数量：
          <span style="color:#C7FF06;fontSize:20px">{{investment.counts}}</span>
        </p>
        <p style="color:#fff;fontSize:16px">
          平台监测项目总投资：
          <span style="color:#C7FF06;fontSize:22px">{{investment.value}}</span>万元
        </p>
      </div>
      <div :id="'inverst'+tag"></div>
    </div>
    <div class="aside">
      <div class="top">
        <p style="color:#fff;fontSize:18px;textAlign:center">全县投资情况</p>
        <div class="conBox">
          <div class="sinCity">
            <div class="left">
              <img v-if="this.industriaSspeed>=0" src="../../../assets/imgs/icon/icon_toup.png" alt />
              <img
                v-if="this.industriaSspeed<0"
                src="../../../assets/imgs/icon/icon_todown.png"
                alt
              />
              <div :style="{color:this.industriaSspeed>0?'#FF0000':'#00FF0A'}">{{industriaSspeed}}%</div>
            </div>
            <div class="text">工业投资增速</div>
          </div>
          <div class="sinCity">
            <div class="left">
              <img v-if="this.technicalSpeed<0" src="../../../assets/imgs/icon/icon_todown.png" alt />
              <img v-if="this.technicalSpeed>=0" src="../../../assets/imgs/icon/icon_toup.png" alt />
              <div :style="{color:this.industriaSspeed>0?'#FF0000':'#00FF0A'}">{{technicalSpeed}}%</div>
            </div>
            <div class="text">技改投资增速</div>
          </div>
        </div>
      </div>
      <div :class="'minddleSurvey'+tag"></div>
      <div :class="'bottomSurvey'+tag"></div>
    </div>
  </div>
</template>

<script>
import { MapJson } from "@/assets/mapJson.js";
import {
  inverstPieSin,
  inverstCitySin,
  investTerraceSin
} from "@/utils/echarts_set.js";
export default {
  props: ["tag"],
  data() {
    return {
      industriaSspeed: "",
      technicalSpeed: "",
      //投资统计数据
      inverstStatusArr: [
        {
          title: "项目总投资",
          num: "-",
          unit: "亿元"
        },
        {
          title: "项目数",
          num: "-",
          unit: "个"
        },
        {
          title: "计划投资",
          num: "-",
          unit: "亿元"
        },
        {
          title: "已完成投资",
          num: "-",
          unit: "亿元"
        }
      ],
      //投资地图卡片数据
      investment: {
        name: " - ",
        value: parseInt(0 / 3),
        counts: " - "
      },
      //打点的坐标信息
      geoCoordMap: {
        老城区: [112.477298, 34.682945],
        涧西区: [112.399243, 34.654251],
        西工区: [112.443232, 34.667847],
        瀍河回族区: [112.491625, 34.684738],
        吉利区: [112.584796, 34.899093],
        洛龙区: [112.456634, 34.618557],
        新安县: [112.141403, 34.728679],
        孟津县: [112.443892, 34.826485],
        嵩县: [112.087765, 34.131563],
        栾川县: [111.618386, 33.783195],
        汝阳县: [112.473789, 34.15323],
        宜阳县: [112.179989, 34.516478],
        洛宁县: [111.655399, 34.387179],
        伊川县: [112.429384, 34.423416],
        偃师市: [112.787739, 34.723042]
      },
      //投资使用的数据数组
      investlocValue: [
        {},
        { name: "洛宁县", value: "0", counts: "0" },
        { name: "汝阳县", value: "0", counts: "0" },
        { name: "孟津县", value: "0", counts: "0" },
        { name: "嵩县", value: "0", counts: "0" },
        { name: "吉利区", value: "0", counts: "0" },
        { name: "洛龙区", value: "0", counts: "0" },
        { name: "新安县", value: "0", counts: "0" },
        { name: "栾川县", value: "0", counts: "0" },
        { name: "宜阳县", value: "0", counts: "0" },
        { name: "伊川县", value: "0", counts: "0" },
        { name: "偃师市", value: "0", counts: "0" },
        { name: "老城区", value: "0", counts: "0" },
        { name: "涧西区", value: "0", counts: "0" },
        { name: "西工区", value: "0", counts: "0" },
        { name: "瀍河回族区", value: "0", counts: "0" }
      ],
      inverstPieData: {
        title: "",
        legend: [],
        data: []
      },
      DataMax: 0,
      DataMin: 0
    };
  },
  methods: {
    //轮播切换tooltips
    autohover(inverstChart, num) {
      var count = 0;
      var timeTicketinvest = null;
      timeTicketinvest && clearInterval(timeTicketinvest);
      timeTicketinvest = setInterval(function() {
        inverstChart.dispatchAction({
          type: "downplay",
          seriesIndex: 1
        });
        inverstChart.dispatchAction({
          type: "highlight",
          seriesIndex: 1,
          dataIndex: count
        });
        inverstChart.dispatchAction({
          type: "showTip",
          seriesIndex: 1,
          dataIndex: count
        });
        if (count >= num) {
          count = 0;
        }
        count++;
      }, 10000);
      // inverstChart.on("mouseover", function(params) {
      //   clearInterval(timeTicket);
      //   inverstChart.dispatchAction({
      //     type: "downplay",
      //     seriesIndex: 0
      //   });
      //   inverstChart.dispatchAction({
      //     type: "highlight",
      //     seriesIndex: 0,
      //     dataIndex: params.dataIndex
      //   });
      //   inverstChart.dispatchAction({
      //     type: "showTip",
      //     seriesIndex: 0,
      //     dataIndex: params.dataIndex
      //   });
      // });
      // inverstChart.on("mouseout", function() {
      //   timeTicket && clearInterval(timeTicket);
      //   timeTicket = setInterval(function() {
      //     inverstChart.dispatchAction({
      //       type: "downplay",
      //       seriesIndex: 0
      //     });
      //     inverstChart.dispatchAction({
      //       type: "highlight",
      //       seriesIndex: 0,
      //       dataIndex: count
      //     });
      //     inverstChart.dispatchAction({
      //       type: "showTip",
      //       seriesIndex: 0,
      //       dataIndex: count
      //     });
      //     if (count >= num) {
      //       count = 0;
      //     }
      //     count++;
      //   }, 1000 * 3);
      // });
    },
    //处理数据
    convertData(geoCoordMap, data) {
      var res = [];
      for (var i = 0; i < data.length; i++) {
        var geoCoord = geoCoordMap[data[i].name];
        if (data.garden && geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value / 1.5),
            garden: data[i].garden
          });
        }
        if (!data.garden && geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value / 1.5)
          });
        }
      }
      // for (let j = 0; j < res.length; j++) {
      //   res[j].value[2] = res[j].value[2];
      // }
      return res;
    },
    // 投资卡片播放
    investPic() {
      let _this = this;
      var investShowBoxTimer = null;
      investShowBoxTimer && clearInterval(investShowBoxTimer);
      var i = 0;
      investShowBoxTimer = setInterval(function() {
        _this.investment = _this.investlocValue[i];
        i++;
        if (i > _this.investlocValue.length - 1) i = 1;
      }, 5000);
    },
    //投资地图
    getInverstMap() {
      let _this = this;

      function getMap(data) {
        _this.$echarts.registerMap("luoyang", data);
        var inverstChart = _this.$echarts.init(
          document.getElementById("inverst")
        );
        _this.setInverstOption(inverstChart);

        // inverstChart.on("mouseover", function(params) {
        //   _this.investment = params.data;
        // });

        // inverstChartR.on("mouseover", function(params) {
        //   _this.investment = params.data;
        // });
      }
      getMap(MapJson);
    },
    //投资地图应用配置
    setInverstOption(inverstChart) {
      let _this = this;
      var inverstMapOption = {
        color: ["#D01864", "#F2F832", "#25CEF3"],
        backgroundColor: "rgba(255,255,255,0)", //背景色
        title: {
          text: "", //标题内容
          x: "center", //标题位置
          textStyle: {
            color: "#fff" //标题颜色
          }
        },
        grid: {
          right: 100,
          top: "center"
        },
        tooltip: {
          //提示信息
          trigger: "item",
          formatter: function(params) {
            if (!isNaN(params.value)) {
              return (
                params.name +
                "<br>" +
                "项目数量:" +
                params.data.counts +
                "个" +
                "<br>" +
                "平台监测项目总投资:" +
                params.data.value +
                "万"
              );
              // params.name + " : " + params.value;
            }
          },
          extraCssText: "background:#0ADAFF;padding:20px 10px", //编辑tooltip的css样式
          textStyle: {
            fontSize: 22
          }
        },
        visualMap: {
          //左下角数据颜色映射
          max: _this.DataMax,
          min: _this.DataMin,
          show: true,
          left: 20,
          bottom: 100,
          itemWidth: 10,
          itemHeight: 150,
          calculable: true,
          inRange: {
            color: ["#25CEF3", "#F2F832", "#D01864"]
          },
          textStyle: {
            color: "rgba(255,255,255)"
          }
          // text: ["最大值", "最小值"]
        },
        geo: {
          //地图配置
          map: "luoyang",
          roam: false, //开启缩放scale 和拖动move  true 同时开启
          aspectScale: 1, //地图长宽比
          selectedMode: "single", //鼠标点击选中
          label: {
            normal: {
              show: false
            },
            emphasis: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              areaColor: "#2B91B7",
              borderColor: "#111",
              shadowBlur: 1,
              shadowColor: "#5F6476",
              shadowOffsetX: 2,
              shadowOffsetY: 2
            },
            emphasis: {
              areaColor: "#2B91B7",
              shadowBlur: 1,
              shadowColor: "#5F6476",
              shadowOffsetX: 5,
              shadowOffsetY: 5
            }
          }
        },
        series: [
          {
            name: "红色代表增涨最多",
            type: "effectScatter", //涟漪特效散点图
            showEffectOn: "render", //涟漪特效展示时机
            rippleEffect: {
              //涟漪特效配置
              scale: 15, //涟漪扩散倍数
              period: 10 //涟漪动画周期
              // brushType: 'stroke'
            },
            hoverAnimation: true,
            coordinateSystem: "geo",
            data: _this //暂时自定义处理数据
              .convertData(_this.geoCoordMap, _this.investlocValue),
            symbolSize: function(val) {
              //图标大小
              return 0;
            },
            label: {
              normal: {
                formatter: "{b}",
                position: "right",
                show: true,
                color: "#fff"
              },
              emphasis: {
                show: false
              }
            },
            itemStyle: {
              emphasis: {
                borderColor: "#fff",
                borderWidth: 1
              }
            },
            zlevel: 1
          },
          {
            type: "map",
            map: "luoyang",
            geoIndex: 0,
            aspectScale: 1, //长宽比
            showLegendSymbol: false, // 存在legend时显示
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false,
                textStyle: {
                  color: "#fff"
                }
              }
            },
            roam: false,
            animation: false,
            data: _this.investlocValue.map(res => {
              res = { name: res.name, value: res.value, counts: res.counts };
              return res;
            }),
            itemStyle: {
              normal: {
                areaColor: "#031525",
                borderColor: "#FFFFFF"
              },
              emphasis: {
                areaColor: "#2B91B7"
              }
            }
          }
        ]
      };
      inverstChart.setOption(inverstMapOption);
      this.autohover(inverstChart, 15);
    },
    // 普通图表自动播放
    normalTable(echart, num) {
      let _this = this;
      var index = 0; //播放所在下标
      var mTimeinvest = null;
      mTimeinvest && clearInterval(mTimeinvest);
      mTimeinvest = setInterval(function() {
        echart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: index
        });
        index++;
        if (index > num) {
          index = 0;
        }
      }, 5000);
    },
    //加载表格echarts配置
    setEchartsOption() {
      let _this = this;
      // 饼图
      var pieThreeL = _this.$echarts.init(document.querySelector("#pieTwo"));
      pieThreeL.setOption(
        inverstPieSin(
          this.inverstPieData.title,
          this.inverstPieData.legend,
          this.inverstPieData.data
        )
        //   "",
        //   [
        //     "电子信息",
        //     "高端石化",
        //     "先进装备制造",
        //     "生物医药",
        //     "新能源",
        //     "机器人与智能制造"
        //   ],
        //   [
        //     { value: 49, name: "电子信息" },
        //     { value: 23, name: "高端石化" },
        //     { value: 107, name: "先进装备制造" },
        //     { value: 14, name: "生物医药" },
        //     { value: 8, name: "新能源" },
        //     { value: 57, name: "机器人与智能制造" }
        //   ]
        // )
      );
      this.normalTable(pieThreeL, 6);

      //各区县投资情况
      var inverstCityEchartsL = _this.$echarts.init(
        document.querySelector(".minddleSurvey")
      );
      inverstCityEchartsL.setOption(inverstCitySin);
      this.normalTable(inverstCityEchartsL, 14);
      //平台检测情况  investTerrace
      var investTerraceEchartsL = _this.$echarts.init(
        document.querySelector(".bottomSurvey")
      );
      investTerraceEchartsL.setOption(investTerraceSin);
      this.normalTable(investTerraceEchartsL, 8);
    },
    getData() {
      // 获取全市投资情况
      this.$axios
        .get("/business/investmentMonitoring/investmentInTheCity")
        .then(res => {
          this.industriaSspeed = res.data.industrySpeed;
          this.technicalSpeed = res.data.techSpeed;
        });

      // 三大改造
      this.$axios
        .get("/business/investmentMonitoring/threeTransformationsDetail")
        .then(res => {
          inverstCitySin.series[0].data = res.data.yAxis;
          inverstCitySin.xAxis.data = res.data.xAxis;
          this.setEchartsOption();
        });

      // 项目投资 平台监测项目情况
      this.$axios
        .get("/business/investmentMonitoring/industryProducts")
        .then(res => {
          investTerraceSin.series[1].data = res.data.planNewArr;
          investTerraceSin.series[0].data = res.data.planCompletedArr;
          var month = [];
          for (let i = 0; i < res.data.xAxis.length; i++) {
            month.push(res.data.xAxis[i] + "月");
          }
          investTerraceSin.xAxis.data = month;
          this.setEchartsOption();
        });

      // 项目投资 平台监测项目情况 项目数量
      this.$axios
        .get("/business/investmentMonitoring/projectMonitorCounts")
        .then(res => {
          this.inverstStatusArr[0].num = res.data.totalInvestment;
          this.inverstStatusArr[1].num = res.data.projectCount;
          this.inverstStatusArr[2].num = res.data.plannedInvestment;
          this.inverstStatusArr[3].num = res.data.completedInvestment;
        });

      // 平台监测“565”产业投资分类
      this.$axios
        .get("/business/investmentMonitoring/investmentClassification")
        .then(res => {
          var arrData = [];
          this.inverstPieData.legend = res.data.indexNameArr;

          for (let i = 0; i < res.data.dataArr.length; i++) {
            var obj = {};
            obj.value = res.data.dataArr[i];
            arrData.push(obj);
          }
          for (let i = 0; i < res.data.indexNameArr.length; i++) {
            arrData[i].name = res.data.indexNameArr[i];
          }
          this.inverstPieData.data = arrData;
          this.setEchartsOption();
        });

      //热力板块图(各区县项目总投资)
      this.$axios
        .get("/business/investmentMonitoring/totalProjectInvestment")
        .then(res => {
          this.investlocValue = [];
          for (let i = 0; i < res.data.length; i++) {
            var obj = {};
            obj.name = res.data[i].area;
            obj.value = Number(res.data[i].investment);
            obj.counts = res.data[i].count;

            this.investlocValue.push(obj);
          }

          this.DataMax = this.investlocValue[0].value;
          this.DataMin = this.investlocValue[0].value;
          for (var i = 0; i < this.investlocValue.length - 1; i++) {
            this.DataMax =
              this.DataMax < this.investlocValue[i + 1].value
                ? this.investlocValue[i + 1].value
                : this.DataMax;
            this.DataMin =
              this.DataMin > this.investlocValue[i + 1].value
                ? this.investlocValue[i + 1].value
                : this.DataMin;
          }
          this.getInverstMap();
        });
    }
  },
  mounted() {
    this.setEchartsOption();
    this.getInverstMap();
    this.investPic();
    this.getData();
  }
};
</script>

<style lang="less" scoped>
.invest {
  justify-content: space-between;
  padding: 0 20px;
  .aside {
    display: flex;
    flex-direction: column;
    width: 480px;
    .top {
      height: 100px;
      box-sizing: border-box;
      padding: 4px 10px;
      background: url(../../../assets/imgs/background/invest_top_bg.png) center
        no-repeat;
      background-size: 480px 100px;
      p {
        margin: 8px 0;
      }
      .conBox {
        display: flex;
        justify-content: space-around;
        .sin {
          width: 23%;
          border: 1px solid #00fcf9;
          color: #fff;
          border-radius: 3px;
          padding-left: 5px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          height: 44px;
          text-align: center;
          p {
            margin: 0;
          }
        }
        .sinCity {
          width: 124px;
          height: 44px;
          background: url(../../../assets/imgs/background/city_inverst_bg.png)
            center no-repeat;
          background-size: cover;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left {
            font-size: 12px;
            width: 44px;
            height: 44px;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            img {
              width: 12px;
              height: 8px;
            }
          }
          .text {
            flex: 1;
            text-align: center;
            color: #00f7ff;
            font-size: 12px;
          }
        }
      }
    }
    .asideSurvey {
      margin-top: 100px;
      box-sizing: border-box;
      padding-top: 20px;
      height: 350px;
      background: url(../../../assets/imgs/background/invest_left_bg.png) center
        no-repeat;
      background-size: cover;
      p {
        font-size: 24px;
        text-align: center;
        color: #fff;
      }
      #pieOne {
        height: 0;
        width: 630px;
      }
      #pieTwo {
        height: 280px;
        width: 630px;
      }
      #pieThree {
        height: 0;
        width: 630px;
      }
    }
    .minddleSurvey {
      margin-top: 10px;
      height: 290px;
      width: 480px;
      background: url(../../../assets/imgs/background/invest_right_part1_bg.png)
        center no-repeat;
      background-size: 480px 290px;
    }
    .bottomSurvey {
      margin-top: 10px;
      height: 310px;
      width: 480px;
      background: url(../../../assets/imgs/background/invest_right_part2_bg.png)
        center no-repeat;
      background-size: 480px 310px;
    }
  }
  .center {
    width: 800px;
    height: 720px;
    position: relative;
    .totalSurver {
      box-sizing: border-box;
      position: absolute;
      z-index: 1000;
      top: 14px;
      left: 14px;
      width: 245px;
      height: 182px;
      padding: 28px 0 0 35px;
      background: url(../../../assets/imgs/background/inverst_map_bg.png) center
        no-repeat;
      background-size: 245px 182px;
      p {
        margin: 10px 0;
      }
    }
    #inverst {
      width: 800px;
      height: 720px;
    }
  }
}
</style>